import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export const uploadFile = async (file: File) => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const formData = new FormData()
  formData.append('file_obj', file)

  const response = await fetch(`${BASE_URL_API}/companies/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    body: formData,
  })

  if (!response.ok) {
    throw new Error('Erro ao fazer upload do arquivo.')
  }
}
